<template>
    <div class="g-popup del-account-popup" v-show="show">
        <div v-if="isWx" id="ams_loginWxDiv" style="width: 300px; height: 460px; border: 1px solid rgb(204, 204, 204); padding: 0px 20px; margin: -231px 0px 0px -171px; position: fixed; z-index: 9999; top: 50%; left: 50%; display: block; background-color: rgb(255, 255, 255); visibility: visible;">
            <span id="ams_btn_closebtn" style="float: right; height: 40px; width: 40px; line-height: 36px; text-align: center; font-size: 30px; margin-right: -20px; cursor: pointer; color: rgb(102, 102, 102); font-family: Verdana, sans-serif;" @click="show = false">×</span>
            <div id="ams_container_wxlogin">
                <iframe :src="url" frameborder="0" scrolling="no" width="300px" height="400px"></iframe>
            </div>
        </div>
        <div v-if="!isWx" class="popup-con login-popup-con" id="login-pop">
            <!-- style="display:block;width:1000px;height: 580px;margin: 60px auto 0;" -->
            <div class="popup-close js-close-view" @click="show = false"><i class="ico ico-close"></i></div>
            <iframe :src="url" frameborder="0"  id="tgl-login__pop" width="622" height="600"  scrolling="no"></iframe>
        </div>
    </div>
</template>
<style lang="scss">
    #login-pop{
        width: 622px;
        height: 605px;
        padding-top: 55px;
    }
</style>
<script>
import {
    WXbind, QQbind 
} from 'Services/getData';

// import bindMedia from 'Components/v4/pop/bind_media.vue';
export default {
    data() {
        return {
            show: false,
            url: '',
            isWx: false
        }
    },
    components: {},
    mounted(){
            
    },
    methods: {
        async toBind(type = 'wx'){
            this.url = '';
            if(type == 'wx'){
                this.isWx = true;
                let res = await WXbind();
                this.url = res.data.data.url;
            }else{
                this.isWx = false;
                let res = await QQbind();
                this.url = res.data.data.url;
            }
            // 微信游戏圈绑定
            window.bindFailure = (message)=>{
                this.show = false;
                this.$alert(message)
            };
            window.bindSuccess = (message)=>{
                this.show = false;
                if(this.$route.query.type === 'bindqq'){
                    this.$route.query.bindend = 1
                }
                location.reload();
                // alert(message)
            };
            this.show = true;
        }
    }
}
</script>
